// A lead is "yours" when you're the assigned agent or a co-agent on it.
// createdby deliberately does NOT count — staff entering a lead on another
// agent's behalf shouldn't surface it under their own name.
//
// ownerlessFallback: an OWNERLESS lead (no assignedAgent) counts for its
// creator. Only the agents' own forced-self boards pass this, so their
// unassigned entries don't vanish on them. The privileged agent PICKER never
// passes it — picking a name means strictly assigned/co-agent; ownerless
// leads are found under "All Agents" instead.
export const isOnLead = (lead, agentId, { ownerlessFallback = false } = {}) =>
  !!agentId &&
  (lead?.assignedAgent === agentId ||
    (Array.isArray(lead?.coAgents) &&
      lead.coAgents.some((c) => c?.id === agentId)) ||
    (ownerlessFallback && !lead?.assignedAgent && lead?.createdby === agentId));

// Never persist a lead without an owner. An unassigned lead is invisible in
// every per-agent pipeline view (it only shows under "All Agents"), so it
// silently "disappears" — 831 Fairview (2026-07-15) was created with no agent
// and couldn't be found. Fall back to whoever created/entered it; a human can
// reassign from the lead drawer. Every saveListingLead / saveBuyerLead runs a
// lead through this, so no creation path can leave one ownerless.
export const ensureLeadOwner = (data = {}) => {
  const assignedAgent =
    data.assignedAgent || data.createdby || data.enteredBy || "";
  if (assignedAgent === data.assignedAgent) return data;
  return { ...data, assignedAgent };
};
